<template>
  <div class="page-login">
    <div class="login-box">
      <div class="login-logo">
        <img src="@/assets/images/layouts/logo_red.png"/>
      </div>
      <div class="login-container">
        <el-form ref="loginForm" :model="form" label-width="80px">
          <div class="login-title">
            <span>Login</span>
          </div>
          <el-input type="text" placeholder="Email" v-model="form.email" class="login-input" />
          <el-input type="password" placeholder="Password" v-model="form.password" class="login-input" />
          <el-button v-on:click="login" class="login-btn" :loading="loadingLogin">Login</el-button>
          <hr class="login-divide" />
          <!-- <div class="login-register">
            <span>Don't have a free account?</span>
            <router-link to="/register">CREATE ONE</router-link>
          </div> -->
          <div class="login-recover">
            <span>Forgot your password?</span>
            <router-link to="/recover">Recover Account</router-link>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      loadingLogin: false
    }
  },
  methods: {
    login () {
      const { email, password } = this.form
      if (email.length <= 0 || password.length <= 0) {
        this.$message.warning('Email and Password are required')
        return
      }
      this.loadingLogin = true
      this.$store.dispatch('login', { email, password }).then(() => {
        this.$message({ type: 'success', message: 'Login success' })
        setTimeout(() => {
          this.$router.push({
            path: this.$route.query.redirect || '/client'
          })
        }, 500)
      }).catch(err => {
        if (err) {
          this.$message.error(err.message)
        }
      }).then(() => {
        this.loadingLogin = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-login {
  padding: 10px;
  min-height: 100vh;
  background: #242A34;
  background-image: url('~@/assets/images/users/bg.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  .login-box {
    width: 500px;
    margin: 6% auto 0;
    background-color: rgba(46, 54, 68, 0.4);
    border-radius: 10px;
    color: white;
    padding: 50px;
    .login-logo {
      margin-bottom: 20px;
      img {
        width: 150px;
        margin: auto;
      }
    }
    .login-container {
      padding: 20px;
      border-top: 0;
      color: #666;
      .login-title {
        margin-bottom: 36px;
        text-align: center;
        color: $theme;
        font-size: 30px;
        font-weight: 300;
      }
      .login-input {
        margin-bottom: 26px;
        input {
          color: #C4C4C4;
          background-color: rgba(85,94,102,0.4);
          border-color: #A6ABAF;
          box-shadow: none;
          height: 35px;
          line-height: 35px;
          padding: 5px 6px;
        }
      }
      .login-btn {
        width: 100%;
        margin-top: 5px;
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 0.5px;
        background-color: red;
        border-color: red;
        height: 35px;
        min-height: auto;
        padding: 0;
        color: white;
      }
      .login-divide {
        width: 100%;
        margin: 30px 0;
        border-width: 1px;
        border-color: hsla(0,0%,100%,.1);
      }
      .login-register {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px;
        color: white;
        font-size: 16px;
        a {
          color: #6098DA;
          text-decoration: none;
        }
      }
      .login-recover {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #C4C4C4;
        font-size: 14px;
        a {
          margin-left: 10px;
          color: #A5C2CB;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
